/** Gerado por scripts/embed-build-info.mjs — não editar. */
export const buildInfo = {
  packageVersion: "0.0.0",
  buildId: "7496",
  buildNumber: "20260525.1",
  sourceVersion: "c74e950c07aacfded6b7ad8805a07a0e2bc8c9a3",
  builtAt: "2026-05-25T21:26:50.204Z",
} as const;
